<app-filter-panel [fields]="fieldsConfig" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>
    <span class="w-full input-field p-input-icon-right" style="max-width: 100px">
        <input pInputText placeholder="Código postal" [(ngModel)]="filters.zipCode.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.zipCode.value" class="pi pi-times cursor-pointer"
            (click)="filters.zipCode.value = null; search()"></i>
    </span>
    <span class="input-field">
        <p-dropdown [options]="countries" [(ngModel)]="filters.countryId.value" optionValue="id"
            [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione pais"
            (onChange)="onCountryChange($event);search()"
            d-form-field-error showClear />
    </span>
    <span class="input-field">
        <p-dropdown [options]="countriesRegions" [(ngModel)]="filters.countryRegionId.value" optionValue="id"
            [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione provincia"
            (onChange)="search()"
            d-form-field-error showClear />
    </span>
</div>
-->

<p-table #grid [value]="zones" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="title"></p-sortIcon></th>
            <th pSortableColumn="country.name">País <p-sortIcon field="country.name"></p-sortIcon></th>
            <th pSortableColumn="countryRegion.name">Provincia <p-sortIcon field="countryRegion.name"></p-sortIcon></th>
            <th pSortableColumn="active">Activo <p-sortIcon field="active"></p-sortIcon></th>
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-zone let-columns="columns">
        <tr (dblclick)="edit(zone)">
            <td>{{zone.name}}</td>
            <td>{{zone.country?.name}}</td>
            <td>{{zone.countryRegion?.name}}</td>
            <td><i class="pi"
                    [ngClass]="{ 'text-green-500 pi-check-circle': zone.active, 'text-red-500 pi-times-circle': !zone.active }"></i>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="delete(zone)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(zone)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>